export default {
  // Grey general note (restored per PM video) — the full one-per-order rule, shown on the
  // offer sheet and the promo/gift modal. Automatic discounts (smart pricing) still stack.
  general_note:
    'Codurile promoționale și cardurile cadou nu pot fi combinate cu alte reduceri. O ofertă și o răscumpărare de puncte pot fi folosite împreună. Reducerile automate, cum ar fi reducerea pentru ridicare, se aplică în continuare.',
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: 'Codurile promoționale și cardurile cadou nu pot fi combinate cu alte reduceri.',
  // Green status pill on the offer sheet when the offer's requirement is met (prototype).
  unlocked: 'Deblocat',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'Nu poate fi combinat cu coduri promoționale sau carduri cadou.',
    promo: 'Nu poate fi combinat cu oferte, carduri cadou sau puncte.',
    gift: 'Nu poate fi combinat cu oferte, coduri promoționale sau puncte.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'Un cod promoțional este aplicat. Aplicarea acestei oferte îl va elimina.',
    offer_blocked_by_gift: 'Un card cadou este aplicat. Aplicarea acestei oferte îl va elimina.',
    offer_blocked_by_points: 'O răscumpărare de puncte este activă. Aplicarea acestei oferte o va elimina.',
    promo_gift_displaces_offer: 'Aplicarea unui cod promoțional sau card cadou va elimina oferta ta activă.',
    promo_gift_displaces_points: 'Aplicarea unui cod promoțional sau card cadou va elimina răscumpărarea ta de puncte.',
    promo_gift_displaces_offer_and_points:
      'Aplicarea unui cod promoțional sau card cadou va elimina oferta activă și răscumpărarea de puncte.',
  },
  // Comparison-choice card (Inc 4, FOO-2567) — offer / promo detail modals when a conflicting
  // discount is already applied. Lets the customer pick, flagging the higher saving as best.
  comparison: {
    active_line: 'Acest {{kind}} este deja activ: {{name}} ({{saving}}).',
    active_line_no_saving: 'Acest {{kind}} este deja activ: {{name}}.',
    candidate_line: '{{kind}} economisește {{saving}}.',
    only_one: 'Poți folosi doar unul.',
    best_choice: 'Cea mai bună alegere',
    keep: 'Păstrează {{label}}',
    use_instead: 'Folosește {{label}} în schimb',
    kinds: {
      offer: 'ofertă',
      promo: 'cod promoțional',
      gift: 'card cadou',
      points: 'răscumpărare de puncte',
    },
    // Concise nouns for the Keep/Use buttons ("Keep offer", "Use code instead").
    button_kinds: {
      offer: 'ofertă',
      promo: 'cod',
      gift: 'card cadou',
      points: 'puncte',
    },
    // Single-action variant (offer modal, promo/gift already active): one sentence + only the
    // "Use offer instead" button — closing the window keeps the code (CTO 2026-08-03).
    single_message:
      '{{active}} este deja activ. Se poate folosi o singură reducere per comandă — folosește această ofertă sau închide fereastra pentru a-ți păstra codul.',
    active_named: {
      promo: 'Cod promoțional {{name}} ({{saving}})',
      gift: 'Card cadou ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Cod promoțional {{name}}',
      gift: 'Card cadou',
    },
    // Multiple active offers (item 6) — promo modal comparison, replaces the active/candidate lines.
    active_offers_two:
      'Ai {{count}} oferte active: {{first}} ({{firstValue}}) și {{second}} ({{secondValue}}) — {{total}} împreună. Codul promoțional {{code}} economisește {{codeValue}} la această comandă. Se poate folosi doar una.',
    active_offers_more:
      'Ai {{count}} oferte active: {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) și {{more}} altele — {{total}} împreună. Codul promoțional {{code}} economisește {{codeValue}} la această comandă. Se poate folosi doar una.',
  },
  // Discount-card status tag (deals carousel — offer + promo cards), Inc 3.
  card: {
    available: 'Disponibil acum',
    applied: 'Aplicat · {{savings}} reducere',
    applied_plain: 'Aplicat',
    replaces: 'Nu poate fi combinat cu {{label}} · Înlocuiește {{name}}',
    replaces_no_name: 'Nu poate fi combinat cu {{label}}',
    // Prototype card treatment (blocked-by-conflict): a warning line naming the active discount,
    // the one-per-order note, and a "Replaces …" line.
    cannot_combine: 'Nu poate fi combinat cu {{name}}',
    replaces_name: 'Înlocuiește {{name}}',
    // Multiple active offers (n>1) — show a count + total instead of a single offer name (item 6).
    cannot_combine_offers: 'Nu poate fi combinat cu cele {{count}} oferte active',
    replaces_offers: 'Înlocuiește {{count}} oferte active ({{total}})',
    // Generic type label for the active discount that would be displaced.
    kind: {
      offer: 'o ofertă',
      promo: 'un cod promoțional',
      gift: 'un card cadou',
      points: 'răscumpărarea ta de puncte',
    },
  },
  // DisplacementNotice (cart drawer + checkout) — bidirectional & entity-named (PM video).
  // One discount displaced another; the message names both, and Undo restores the displaced one.
  // e.g. "Promo code CHEVERE applied. This removed the 2-für-1 offer. [Undo]".
  displacement: {
    message: '{{applied}} aplicat. Aceasta a eliminat {{removed}}.',
    // Multiple offers removed at once (item 6) — names the top two + the total, in cart + checkout.
    offer_removed_multi: {
      promo:
        'Codul promoțional {{code}} ({{codeValue}}) aplicat. Aceasta a eliminat {{count}} oferte: {{first}} și {{second}} ({{total}}).',
      gift: 'Card cadou aplicat. Aceasta a eliminat {{count}} oferte: {{first}} și {{second}} ({{total}}).',
    },
    undo: 'Anulează',
    // The discount that is currently applied (the "winner").
    applied: {
      offer: 'Oferta {{name}}',
      promo: 'Cod promoțional {{code}}',
      gift: 'Card cadou',
      points: '{{count}} puncte',
    },
    // The discount that was displaced (the "loser"), restored by Undo.
    removed: {
      offer: 'oferta {{name}}',
      promo: 'codul promoțional {{code}}',
      gift: 'cardul cadou',
      points: 'răscumpărarea ta de puncte',
    },
    // UX feedback item 3 — points redemption displacing a promo/gift. Layer A: a zero-friction hint
    // under the "Use your points" header, shown only while a code/gift is active (before they tap).
    points_hint: {
      promo: 'Folosirea punctelor va elimina codul promoțional {{name}} (–{{saving}})',
      gift: 'Folosirea punctelor va elimina cardul cadou (–{{saving}})',
      promo_no_saving: 'Folosirea punctelor va elimina codul promoțional {{name}}',
      gift_no_saving: 'Folosirea punctelor va elimina cardul cadou',
    },
    // Layer B: the post-action displacement notice, extended to the points→code direction.
    points_displaced: {
      promo:
        '{{points}} puncte aplicate (–{{pointsSaving}}). Codul promoțional {{name}} (–{{couponSaving}}) a fost eliminat.',
      gift: '{{points}} puncte aplicate (–{{pointsSaving}}). Cardul cadou (–{{couponSaving}}) a fost eliminat.',
      promo_no_saving: '{{points}} puncte aplicate (–{{pointsSaving}}). Codul promoțional {{name}} a fost eliminat.',
      gift_no_saving: '{{points}} puncte aplicate (–{{pointsSaving}}). Cardul cadou a fost eliminat.',
    },
  },
};
